import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Button from '../elements/Button';
import { useTranslation } from '../../i18n/LanguageProvider';

const propTypes = {
  ...SectionTilesProps.types
};

const defaultProps = {
  ...SectionTilesProps.defaults
};

const iconProps = {
  width: 48,
  height: 48,
  viewBox: '0 0 48 48',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true,
  focusable: false
};

const contactEmail = 'contato@algorcode.com.br';

const ContactChannels = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  invertColor,
  pushLeft,
  ...props
}) => {
  const { t } = useTranslation();

  const outerClasses = classNames(
    'contact-channels section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'contact-channels-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames(
    'tiles-wrap center-content',
    pushLeft && 'push-left'
  );

  const sectionHeader = t('contactChannels.header');

  const channels = [
    {
      key: 'whatsapp',
      title: t('contactChannels.whatsapp.title'),
      description: t('contactChannels.whatsapp.description'),
      ctaLabel: t('contactChannels.whatsapp.cta'),
      ctaLink: 'https://wa.me/5512988340989',
      icon: (
        <svg {...iconProps}>
          <path d="M24 4c11.046 0 20 8.402 20 18.75 0 10.349-8.954 18.75-20 18.75a21.33 21.33 0 01-9.711-2.286L8 44l3.266-9.28C9.137 31.984 8 28.493 8 24.75 8 12.402 16.954 4 24 4zm0 4.5c-7.495 0-13.586 5.676-13.586 12.75 0 3.176 1.281 6.164 3.65 8.534l.58.563-1.604 4.563 4.9-1.55.642.384a17.22 17.22 0 008.418 2.215c7.495 0 13.586-5.676 13.586-12.75S31.495 8.5 24 8.5zm.236 5.625c.346-.007.712.002 1.114.029 1.276.084 1.917.649 2.085 1.141.17.492.17 1.61-.409 2.51-.579.9-1.706 2.183-1.706 2.183s-.3.352-.41.662c-.11.31-.044.517.065.724.109.208.725 1.19 1.577 1.931.863.752 1.915 1.226 2.246 1.364.331.138.526.128.736-.076.21-.204.863-1 1.069-1.344.206-.344.418-.29.702-.186.284.103 1.798.848 2.105 1.002.307.155.512.23.587.357.075.127.075 1.046-.261 2.052-.335 1.006-1.994 1.974-2.733 2.034-.739.059-1.348.242-2.297-.167-.949-.409-3.02-1.364-4.653-3.021-1.632-1.656-2.757-3.808-3.07-4.366-.314-.558-.3-2.196.208-3.264.507-1.069 1.641-2.693 2.285-3.47.643-.777 1.28-.764 1.626-.772z" />
        </svg>
      )
    },
    {
      key: 'email',
      title: t('contactChannels.email.title'),
      description: t('contactChannels.email.description', { email: contactEmail }),
      ctaLabel: t('contactChannels.email.cta'),
      ctaLink: `mailto:${contactEmail}`,
      icon: (
        <svg {...iconProps}>
          <path d="M8 10h32a2 2 0 012 2v24a2 2 0 01-2 2H8a2 2 0 01-2-2V12a2 2 0 012-2zm2 5.236V34h28V15.236l-14 9.333-14-9.333zM10.832 12L24 20.764 37.168 12H10.832z" />
        </svg>
      )
    },
    {
      key: 'meeting',
      title: t('contactChannels.meeting.title'),
      description: t('contactChannels.meeting.description'),
      ctaLabel: t('contactChannels.meeting.cta'),
      ctaLink: 'mailto:contato@algorcode.com.br?subject=Quero%20agendar%20uma%20reuniao',
      icon: (
        <svg {...iconProps}>
          <path d="M16 6v2H8v28h32V8h-8V6h4a2 2 0 012 2v28a2 2 0 01-2 2H8a2 2 0 01-2-2V8a2 2 0 012-2h8zm4 0h8v2h-8V6zm-4 10h24v2H16v-2zm0 8h24v2H16v-2zm0 8h14v2H16v-2z" />
          <path d="M30 2h2v8h-2zM20 2h2v8h-2z" />
        </svg>
      )
    }
  ];

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={tilesClasses}>
            {channels.map((channel, index) => (
              <div className="tiles-item reveal-from-bottom" data-reveal-delay={index * 200} key={channel.key}>
                <div className="tiles-item-inner">
                  <div className="contact-channel-icon mb-16">
                    {channel.icon}
                  </div>
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">{channel.title}</h4>
                    <p className="m-0 mb-16 text-sm">
                      {channel.description}
                    </p>
                    <Button tag="a" color="primary" wideMobile href={channel.ctaLink}>
                      {channel.ctaLabel}
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

ContactChannels.propTypes = propTypes;
ContactChannels.defaultProps = defaultProps;

export default ContactChannels;
